import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from 'src/app/shared/_helpers/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private _authenticationService: AuthenticationService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const userData = this._authenticationService.currentUserDataValue;
        if (userData) {
            switch (userData.accountType) {
                case 1:
                    if (route.url.length > 0) {
                        if (route.url[0].path === 'user') {
                            return true;
                        }
                    }
                    this.router.navigate(['/user', 'counter', userData.orgId]);
                    return false;
                // For the case of the VSS users
                case 5:
                case 6:
                case 7:
                    if (state.url.includes('vss')) {
                        return true;
                    }
                    this.router.navigate(['/vss']);
                    return false;
            }
            if (state.url.includes('vss')) {
                this.router.navigate(['/']);
                return false;
            }
            return true;
        }
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login']);
        return false;
    }
}
